import { render } from "./DunningData.vue?vue&type=template&id=055e6d04"
import script from "./DunningData.vue?vue&type=script&lang=js"
export * from "./DunningData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__